import { collection, getDocs, getFirestore } from 'firebase/firestore';
import { getApp } from 'firebase/app';
import { DBCollection } from '@/lib/utils/constants-shared';
import { fetchCollectionFromStorage } from '@/lib/utils/storage-bulk-data';
import type { FirebaseStorage } from 'firebase/storage';

/**
 * Fetch all places from Firestore
 */
export async function fetchPlacesFromDB(storage?: FirebaseStorage): Promise<Place[]> {
    async function fallback() {
        const db = getFirestore(getApp());
        const placesCollection = collection(db, DBCollection.places);
        const snapshot = await getDocs(placesCollection);

        return snapshot.docs.map(doc => {
            const data = doc.data() as FirebasePlace;
            return {
                id: doc.id,
                ...data
            } as Place;
        });
    }

    if (storage) {
        return await fetchCollectionFromStorage<Place>(
            storage,
            `bulk-data/${DBCollection.places}.json`,
            fallback
        );
    }

    return await fallback();
}

